// Only inline type now. Write the new condition to add new popup types

const makePopup = (selector, type) => {

    const $selector = $(selector);

    // var tag = document.createElement('script');
    // tag.src = "https://www.youtube.com/iframe_api";
    // var firstScriptTag = document.getElementsByTagName('script')[0];
    // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    var YTplayer;

    if (type === 'inline') {
        $selector.each(function () {
            let ths = $(this);

            ths.magnificPopup({
                src: $(this).attr('href'),
                type: type,
                removalDelay: 300,
                callbacks: {
                    beforeOpen: function () {
                        if(ths.data('yt-video-id')) {
                            initYTPlayer(ths.data('yt-video-id'));
                        }

                        this.st.mainClass = 'mfp-zoom-out';

                        if(ths.hasClass('js-video-popup')){

                            let video = $(ths.attr('href')).find('video').get(0);

                            video.play();

                            setTimeout(function(){
                                if(video.paused) {
                                    video.play();
                                }
                            },100)
                        }
                    },

                    beforeClose: function () {
                        if(ths.data('yt-video-id')) {
                            stopVideo();
                        }

                        if(ths.hasClass('js-video-popup')){

                            $(ths.attr('href')).find('video')[0].pause()

                        }
                    }
                },
            })
        })
    } else {
        console.log('Write condition for this popup type in make_popup, please');
    }

    function initYTPlayer(videoId) {
        YTplayer = new YT.Player('player', {
            height: '315',
            width: '560',
            videoId: videoId,
            events: {
                'onReady': onYTPlayerReady,
                //'onStateChange': onPlayerStateChange
            }
        });
    }

    function stopVideo() {
        YTplayer.stopVideo();
        $('#player').replaceWith('<div id="player"></div>');
    }

    function playVideo() {
        YTplayer.playVideo();
    }

    function onYTPlayerReady(event) {
        event.target.playVideo();
    }
};

export default makePopup;
